import { parallel } from 'cerebral'
import { merge, set, unset, when } from 'cerebral/operators'
import { state, props, resolveObject } from 'cerebral/tags'
import fetchMedia from '../actions/fetchMedia'
import createSnackbar from 'modules/App/factories/createSnackbar'
import updateSnackbar from 'modules/App/actions/updateSnackbar'
import removeSnackbar from 'modules/App/chains/removeSnackbar'
import getCurrentFileTypes from '../actions/getCurrentFileTypes'

const isFetchCanceled = ({ path, props, state }) =>
  props.fetchId === state.get('media.fetchId') ? path.false() : path.true()

const triggerNextLoad = ({ controller, props }) => {
  setTimeout(
    () => controller.getSignal('media.loadMediaWithFetchId')(props),
    10
  )
}

export const loadMediaWithFetchId = [
  isFetchCanceled,
  {
    false: [
      fetchMedia,
      {
        loaded: [
          isFetchCanceled,
          {
            false: [
              when(props`total`, total => total > 7000),
              {
                true: [set(state`media.fetchCount`, 500)],
                false: []
              },

              when(state`media.firstFetch`),
              {
                true: [
                  set(state`media.files`, {}),
                  set(state`media.firstFetch`, false)
                ],
                false: []
              },
              merge(state`media.files`, props`files`),
              getCurrentFileTypes,
              when(props`snackbar`),
              {
                false: [
                  createSnackbar(
                    resolveObject({
                      key: 'bms.media.fetch.loadingProgress',
                      params: resolveObject({
                        loaded: props`loaded`,
                        total: props`total`
                      })
                    }),
                    'normal',
                    true
                  )
                ],
                true: [
                  ({ props }) => ({
                    snackbar: {
                      id: props.snackbar.id,
                      text: {
                        key: 'bms.media.fetch.loadingProgress',
                        params: { loaded: props.loaded, total: props.total }
                      }
                    }
                  }),
                  updateSnackbar
                ]
              },
              ({ path, props }) =>
                props.total > props.loaded ? path.loadNextBatch() : path.done(),
              {
                loadNextBatch: [triggerNextLoad],
                done: [
                  unset(state`media.fetchCount`),
                  unset(state`media.fetchId`),
                  ...removeSnackbar
                ]
              }
            ],
            true: [removeSnackbar]
          }
        ],
        error: [
          parallel('Error while fetching', [
            removeSnackbar,
            createSnackbar({ key: 'bms.media.errors.fetching' }, 'error')
          ])
        ]
      }
    ],
    true: [removeSnackbar]
  }
]

export default [
  ({ state, uuid }) => {
    const fetchId = uuid.id()
    state.set('media.fetchId', fetchId)

    return { fetchId }
  },
  set(state`media.firstFetch`, true),
  ...loadMediaWithFetchId
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/loadMediaFiles.js